<template>
    <div class="contract-status-container">
        <div
            class="status-circle"
            :class="stateClass"
        ></div>
        <label>{{ stateText }}</label>
        <img
            :title="stateHint"
            class="info"
            src="@img/information-circle.svg"
        />
    </div>
</template>

<script>
const STATE = {
    ACTIVE: 1,
    WILLEND: 2,
    ENDED: 3,
    INDEBT: 4
}
</script>

<script setup>
import { getCurrentInstance, computed, defineProps } from 'vue'

const { proxy } = getCurrentInstance()

const props = defineProps({
    status: {
        type: Object,
        required: true
    }
})

const stateClass = computed(() => {

    switch(props.status?.state) {
        case STATE.ACTIVE: return 'green'
        case STATE.WILLEND: return 'yellow'
        case STATE.ENDED: return 'blue'
        case STATE.INDEBT: return 'red'
        default: return ''
    }
})

const stateText = computed(() => {

    switch(props.status?.state) {
        case STATE.ACTIVE: return proxy.$t('contractState.contract-state-active')
        case STATE.WILLEND: return proxy.$t('contractState.contract-state-will-end')
        case STATE.ENDED: return proxy.$t('contractState.contract-state-ended')
        case STATE.INDEBT: return proxy.$t('contractState.contract-state-in-debt')
        default: return proxy.$t('contractState.contract-state-unknown')
    }
})

const stateHint = computed(() => {

    switch(props.status?.state) {
        case STATE.ACTIVE: return proxy.$t('contractState.contract-state-active-hint')
        case STATE.WILLEND: return proxy.$t('contractState.contract-state-will-end-hint')
        case STATE.ENDED: return proxy.$t('contractState.contract-state-ended-hint')
        case STATE.INDEBT: return proxy.$t('contractState.contract-state-in-debt-hint')
        default: return proxy.$t('contractState.contract-state-unknown-hint')
    }
})
</script>

<style lang="scss" scoped>
.contract-status-container {
    display: flex;
    column-gap: 0.5rem;
    align-items: center;

    > .status-circle {
        width: 1.25rem;
        height: 1.25rem;
        border-radius: 50%;
        background-color: #282d37;

        &.green { background-color: #508b1b; }
        &.yellow { background-color: #fff000; }
        &.blue { background-color: #0087b9; }
        &.red { background-color: #ec0016; }
    }

    > label{
        font-size: 1.2rem
    }
}
</style>